<template>
<div class="chapter">
<div class="inner_page">
<div>
<p class="ORIM-Chapter-Title-Page-Break">PREFACE</p>
<p class="ORIM-Chapter-Opener-Paragraph"><span class="ORIM-Chapter-First-Words">IN THE FOLLOWING PAGES</span> I have confined myself in the main to those problems of philosophy in regard to which I thought it possible to say something positive and constructive, since merely negative criticism seemed out of place. For this reason, theory of knowledge occupies a larger space than metaphysics in the present volume, and some topics much discussed by philosophers are treated very briefly, if at all.</p>
<p class="ORIM-Body-Text">I have derived valuable assistance from unpublished writings of G. E. Moore and J. M. Keynes: from the former, as regards the relations of sense-data to physical objects, and from the latter as regards probability and induction. I have also profited greatly by the criticisms and suggestions of Professor Gilbert Murray.</p>
<p class="ORIM-Body-Text">1912</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Untitled-1-1.vue?bd9eb62e